/*! accordions */

//$(document).ready(function () {

//    // Accordions
//    var accordions = '.accordion-container .accordion-title';
//    $(accordions).click(function (e) {
//        e.preventDefault();
//        var $target = $(e.target);
//        var isVisible = $target.hasClass('active');
//        var $container = $target.closest('.accordion-container');
//        $container.find('.accordion-title').removeClass('active');
//        $container.find('.accordion-content').removeClass('active').attr('aria-hidden', 'true');;
//        if (isVisible != true) {
//            $target.addClass('active');
//            $target.next('.accordion-content').addClass('active').attr('aria-hidden', 'false');;
//            PutElementIntoView($target);
//        }
//    });

//});

$(document).ready(function () {

    // ✅ Add class to language accordion buttons
    $('.accordion-container .accordion-title').each(function () {
        var text = $(this).text().trim();
        if (text === "Español (Spanish)" ||
            text === "中文 (Chinese)" ||
            text === "Tiếng Việt (Vietnamese)" ||
            text === "한국어 (Korean)" ||
            text === "Русский (Russian)" ||
            text === "Українська (Ukrainian)" ||
            text === "ਪੰਜਾਬੀ (Punjabi)") {
            $(this).addClass('language-accordion-title');
        }
    });

    // Accordions
    var accordions = '.accordion-container .accordion-title';
    $(accordions).click(function (e) {
        e.preventDefault();
        var $target = $(e.target);
        var isVisible = $target.hasClass('active');
        var $container = $target.closest('.accordion-container');
        $container.find('.accordion-title').removeClass('active');
        $container.find('.accordion-content').removeClass('active').attr('aria-hidden', 'true');
        if (isVisible != true) {
            $target.addClass('active');
            $target.next('.accordion-content').addClass('active').attr('aria-hidden', 'false');
            PutElementIntoView($target);
        }
    });

});

